import { render, staticRenderFns } from "./LogoFinerFoods.vue?vue&type=template&id=150d4709"
import script from "./LogoFinerFoods.vue?vue&type=script&lang=js"
export * from "./LogoFinerFoods.vue?vue&type=script&lang=js"
import style0 from "./LogoFinerFoods.vue?vue&type=style&index=0&id=150d4709&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports